import { AssetHistoryEvent, BillOfMaterialsLineItem, C3HardwareItem, C3Order, C3OrderedProduct, C3Product, C3ProductBillOfMaterialsLineItem, C3ProductVersion, C3VendorHardwareData, C3RiderBomNode, ClientDevice, ClientDeviceLog, CloudFunctionFlag, ComplaintLog, ComplaintLogProduct, PlasticsHardwareItemShipment, PlasticsHardwareItemShipmentDamageItem, PlasticsHardwareItemShipmentItem, Contact, CribbageGame, CronJob, Customer, DatabaseBackupRecord, DeviceDocumentReads, DirectChat, DirectChatMessage, EngineeringUpdateMeeting, EngineeringUpdateMeetingUserContent, FactoryAsset, FactoryNode, FactoryNodeConfig, FinanceEntry, OvertimeSummaryWeek, GmailUser, GmailUserDevice, GmailUserLogin, InventoryTransaction, KnowledgeDocument, LabelInstance, LabelPrinter, MaintenanceTask, MappingAssetToProcedure, MappingAssetToResource, MappingComplaintLogToContact, MappingComplaintLogToQualityAlert, MappingPlasticsMaterialToQualityAlert, MappingProductVersionToDockInspectionQuailtyAlert, MappingProductVersionToPlasticsStaticLabel, MappingProductVersionToQualityAlert, MappingProductVersionToQuoteStudioCostModel, MappingProductVersionToQuoteStudioQuote, MetalsHardwareItem, MetalsLaserMaterial, MetalsLaserProgram, MetalsMaterial, MetalsOrder, MetalsOrderedProduct, MetalsPowderCoatingPowder, MetalsPressBrakeBendRadius, MetalsProcessStation, MetalsProduct, MetalsProductBillOfMaterialsLineItem, MetalsProductSetup, MetalsProductVersion, MetalsProject, MetalsTask, MetalsTaskQuantityChangeEvent, MetalsVendorHardwareData, MetaltrackJob, MoldRepairRequest, ObsessedEngineeringProduct, SheetMetalJob, SheetMetalSourceFile, SheetMetalPart, PlasticsCalendarEvent, PlasticsDockInspectionInstance, PlasticsFinishingStation, PlasticsFinishingLaborSession, PlasticsFinishingTask, PlasticsFixture, PlasticsHardwareItem, PlasticsInventoryArea, PlasticsInventoryLocation, PlasticsInventoryLocationBin, PlasticsKit, PlasticsKittingArea, PlasticsKittingLocation, PlasticsKittingLocationBin, PlasticsManufacturingRatesParent, PlasticsManufacturingRatesVersion, PlasticsMaterial, PlasticsMaterialMixingTask, PlasticsMold, PlasticsMoldFamily, PlasticsMoldingTask, PlasticsDailyProduction, PlasticsOrder, PlasticsOrderedProduct, PlasticsPurchaseRequisition, PlasticsQualityAlert, PlasticsQualityAlertInspection, PlasticsRework, PlasticsScrapInstance, PlasticsScrapReason, PlasticsSkid, PlasticsStaticLabel, Procedure, ProcedureInstance, ProcedureInstanceStep, ProcedureStepRedline, ProcedureVersion, Product, ProductInstance, ProductVersion, ProductVersionMoldConfig, PurchaseOrder, PurchaseOrderChange, PurchaseRequest, PurchaseRequestArrival, PurchaseRequestList, PurchaseRequestUnreadied, QualityAlertViewTally, Resource, RobotProgram, RobotProgramGroup, RotoMachine, RotoMachineArmTally, ScheduledProcedure, Schematic, SoftwareRequest, SoftwareTask, StampingStation, StampingTask, StorageBackupRecord, Tag, ToolRoomMachine, TrendsDataFileRecord, TrendsShareLink, TriumvirateBarcodeScanningSession, User, UserNotification, UserTimeSession, VacationEvent, Employee, EmployeeRecord, Vendor, VendorHardwareData, VendorHardwareDataPriceHistory, PlasticsShipment, FreightCarrier, SchematicVersion, AutomationHardwareItem, AutomationVendorHardwareData, AutomationFootprint, AutomationFootprintVersion, ObsessedEngineeringOrder, ObsessedEngineeringOrderedProduct, UpsShipment, CustomerAddress, LabelPrinterGroup, WifiOutlet, EngineeringProject, EngineeringProjectEngineer } from "@prism/prism-shared";
import { PlasticsColorCode } from "@prism/prism-shared";
import { CustomerNoteVersion } from '../models/customer.model';
import { KolorcansPackingConfig, KolorcansPackingConfigProduct } from "@prism/prism-shared";
import { PlasticsMoldHistoryEvent } from '../models/plastics-mold-history-event.model';
import { PlasticsMoldCheckup, PlasticsMoldNotice, PlasticsMoldCheckupCommandReceipt } from '../models/plastics-mold-checkup.model';
import { MetalsQuote } from "@prism/prism-shared";
import { MetalsInventoryBin, MetalsInventoryRack } from '../models/metals-inventory.model';
import { PlasticsWeighRequest } from '../models/plastics-weigh-request.model';
import { StorageFolder } from "../enums/storage-folder.enum";
import { ObsessedEngineeringComponent } from "../models/obsessed-engineering-component.model";
import { ObsessedEngineeringComponentShipment, ObsessedEngineeringComponentShipmentDamageItem, ObsessedEngineeringComponentShipmentItem } from "../models/obsessed-engineering-component-shipment.model";
import { ObsessedEngineeringInvoice } from "../models/obsessed-engineering-invoice.model";
import { PlasticsInvoice } from '../models/plastics-invoice.model';
import { ObsessedEngineeringProductVersion } from "../models/obsessed-engineering-product-version.model";
import { ObsessedEngineeringProductBomLineItem } from "../models/obsessed-engineering-product-bom-line-item.model";
import { SuncastSnapshot } from "../models/suncast-snapshot.model";
import { ResinSiloReading } from "../models/resin-silo-reading.model";
import { ResinSiloCaptureRequest } from "../models/resin-silo-capture-request.model";
import { CapitalizationProject, SmartJeffProject } from "@prism/prism-shared";
import { C3InventoryThresholdReport, C3InventoryThresholdReportItem } from "../models/c3-inventory-threshold-report.model";
import { C3Report } from "../models/c3-report.model";
import { MasterProcedure } from "../models/master-procedure.model";
import { MasterProcedureVersion } from "../models/master-procedure-version.model";
import { HotListItem } from "../models/hot-list-item.model";
import { MoldArmCycle } from "../models/mold-arm-cycle.model";
import { HotListOrderItem } from "../models/hot-list-order-item.model";
import { InjectionMoldingHardwareItem } from "../models/injection-molding-hardware-item.model";
import { InjectionMoldingOrder } from "../models/injection-molding-order.model";
import { InjectionMoldingOrderedProduct } from "../models/injection-molding-ordered-product.model";
import { InjectionMoldingProductionEvent } from "../models/injection-molding-production-event.model";
import { InjectionMoldingMaterial } from "../models/injection-molding-material.model";
import { InjectionMoldingMaterialRecipeItem } from "../models/injection-molding-material-recipe-item.model";
import { InjectionMoldingMold, InjectionMoldingMoldSetup } from "../models/injection-molding-mold.model";
import { InjectionMoldingProduct } from "../models/injection-molding-product.model";
import { InjectionMoldingProductBillOfMaterialsLineItem } from "../models/injection-molding-product-bill-of-materials-line-item.model";
import { InjectionMoldingProductVersion } from "../models/injection-molding-product-version.model";
import { C3Graphic } from "../models/c3-graphic.model";
import { C3GraphicVersion } from "../models/c3-graphic-version.model";
import { C3GraphicResource } from "../models/c3-graphic-resource.model";
import { PrintingProduct, PrintingProductVersion, PrintingProductFile, PrintingProductBomItem } from '../models/printing-product.model';
import { MotionmasterProgram, MotionmasterProgramVersion, MotionmasterTable } from '../models/motionmaster-program.model';
import { FactoryMoveRequest } from "../models/factory-move-request.model";
import { InjectionMoldingQualityAlert } from "../models/injection-molding-quality-alert.model";
import { InjectionMoldingVendorHardwareData } from "../models/injection-molding-vendor-hardware-data.model";
import { MappingInjectionMoldingProductVersionToQualityAlert } from "../models/mapping-injection-molding-product-version-to-quality-alert.model";
import { Email } from "../models/email.model";
import { CommonProject, CommonProjectUpdate } from "../models/common-project.model";
import { ResourceSearchPackage } from "../models/resource-search.model";
import { QuoteStudio, QuoteStudioCostModel, QuoteStudioCostModelVersion, QuoteStudioLink, QuoteStudioQuote } from "../models/quote-studio.model";
import { PlasticsOrderReviewResearch } from "../models/plastics-order-review-research.model";

interface LegacyCarrier {
    id: string;
    name: string;
    imageUrl: string;
}

export enum Collection {
    email = 'email',
    cronJob = 'cron-job',
    gmailUserLogin = 'gmail-user-login',
    gmailUser = 'gmail-user',
    gmailUserDevice = 'gmail-user-device',


    factoryNode = 'factory-node',
    factoryNodeConfig = 'factory-node-config',

    plasticsHardwareItem = 'plastics-hardware-item',
    metalsHardwareItem = 'metals-hardware-item',
    vendor = 'vendor',
    customer = 'customer',
    customerNoteVersion = 'customer-note-version',
    customerAddress = 'customer-address',
    metalsMaterial = 'metals-material',
    contact = 'contact',
    product = 'product',
    productVersion = 'product-version',
    billOfMaterialsLineItem = 'bill-of-materials-line-item',
    metalsProductBillOfMaterialsLineItem = 'metals-product-bill-of-materials-line-item',
    resource = 'resource',
    resourceSearchPackage = 'resource-search-package',
    productInstance = 'product-instance',
    procedure = 'procedure',
    procedureVersion = 'procedure-version',
    masterProcedure = 'master-procedure',
    masterProcedureVersion = 'master-procedure-version',
    procedureInstance = 'procedure-instance',
    procedureInstanceStep = 'procedure-instance-step',
    procedureStepRedline = 'procedure-step-redline',
    scheduledProcedure = 'scheduled-procedure',
    plasticsMaterial = 'plastics-material',
    plasticsMaterialMixingTask = 'plastics-material-mixing-task',
    plasticsPurchaseRequisition = 'plastics-purchase-requisition',
    plasticsScrapReason = 'plastics-scrap-reason',
    plasticsScrapInstance = 'plastics-scrap-instance',
    plasticsOrder = 'plastics-order',
    plasticsOrderedProduct = 'plastics-ordered-product',
    plasticsOrderReviewResearch = 'plastics-order-review-research',
    plasticsOrderReviewRulebook = 'plastics-order-review-rulebook',
    plasticsOrderIntake = 'plastics-order-intake',
    plasticsOrderIntakeApproval = 'plastics-order-intake-approval',
    plasticsOrderCase = 'plastics-order-case',
    plasticsCalendarEvent = 'plastics-calendar-event',
    plasticsColorCode = 'plastics-color-code',
    labelPrinter = 'label-printer',
    labelPrinterGroup = 'label-printer-group',
    wifiOutlet = 'wifi-outlet',
    plasticsFinishingTask = 'plastic-finishing-task',
    plasticsFinishingStation = 'plastics-finishing-station',
    plasticsFinishingLaborSession = 'plastics-finishing-labor-session',
    kolorcansPackingConfig = 'kolorcans-packing-config',
    kolorcansPackingConfigProduct = 'kolorcans-packing-config-product',
    cribbageGame = 'cribbage-game',
    metalsProduct = 'metals-product',
    metalsProductVersion = 'metals-product-version',
    stampingStation = 'stamping-station',
    stampingTask = 'stamping-task',
    deviceDocumentReads = 'device-document-reads',
    databaseBackupRecord = 'database-backup-record',
    storageBackupRecord = 'storage-backup-record',
    complaintLog = 'complaint-log',
    complaintLogProduct = 'complaint-log-product',
    plasticsRework = 'plastics-rework',
    rotoMachineArmTally = 'roto-machine-arm-tally',
    qualityAlertViewTally = 'quality-alert-view-tally',
    plasticsLabelInstance = 'plastics-label-instance',
    plasticsQualityAlertInspection = 'plastics-quality-alert-inspection',
    plasticsSkid = 'plastics-skid',
    plasticsShipment = 'plastics-shipment',
    upsShipment = 'ups-shipment',

    factoryAsset = 'factory-asset',
    assetHistoryEvent = 'asset-history-event',

    truckingCarrier = 'trucking-carrier',
    freightCarrier = 'freight-carrier',

    purchaseRequestList = 'purchase-request-list',
    purchaseRequest = 'purchase-request',
    purchaseOrder = 'purchase-order',


    softwareRequest = 'software-request',
    smartJeffProject = 'smart-jeff-project',
    commonProject = 'common-project',
    commonProjectUpdate = 'common-project-update',
    capitalizationProject = 'capitalization-project',

    mappingAssetToResource = 'mapping-asset-to-resource',
    mappingAssetToProcedure = 'mapping-asset-to-procedure',
    mappingProductVersionToQualityAlert = 'mapping-product-version-to-quality-alert',
    mappingProductVersionToDockInspectionQualityAlert = 'mapping-product-version-to-dock-inspection-quality-alert',
    mappingProductVersionToPlasticsStaticLabel = 'mapping-product-version-to-plastics-static-label',
    mappingProductVersionToQuoteStudioCostModel = 'mapping-product-version-to-quote-studio-cost-model',
    mappingProductVersionToQuoteStudioQuote = 'mapping-product-version-to-quote-studio-quote',
    mappingComplaintLogToQualityAlert = 'mapping-complaint-log-to-quality-alert',
    mappingComplaintLogToContact = 'mapping-complaint-log-to-contact',

    robotProgramGroup = 'robot-program-group',
    robotProgram = 'robot-program',
    plasticsFixture = 'plastics-fixture',
    rotoMachine = 'roto-machine',
    clientDevice = 'client-device',
    clientDeviceLog = 'client-device-log',
    softwareTask = 'software-task',
    engineeringUpdateMeeting = 'engineering-update-meeting',
    engineeringUpdateMeetingUserContent = 'engineering-update-meeting-user-content',
    knowledgeDocument = 'knowledge-document',
    dockInspectionInstance = 'dock-inspection-instance',

    trendsDataFileRecord = 'trends-data-file-record',
    trendsShareLink = 'trends-share-link',


    vendorHardwareData = 'vendor-hardware-data',
    vendorHardwareDataPriceHistory = 'vendor-hardware-data-price-history',
    metalsVendorHardwareData = 'metals-vendor-hardware-data',
    user = 'user',
    userTimeSession = 'user-time-session',
    tag = 'tag',


    metalsLaserProgram = 'metals-laser-program',
    metalsLaserMaterial = 'metals-laser-material',
    metalsPressBrakeBendRadius = 'metals-press-brake-bend-radius',
    metalsPowderCoatingPowder = 'metals-powder-coating-powder',

    sheetMetalJob = 'sheet-metal-job',
    sheetMetalSourceFile = 'sheet-metal-source-file',
    sheetMetalPart = 'sheet-metal-part',

    globalVariables = 'global-variables',

    metaltrackJob = 'metaltrack-job',

    plasticsMoldingTask = 'plastics-molding-task',
    plasticsDailyProduction = 'plastics-daily-production',

    userNotification = 'user-notification',
    vacationEvent = 'vacation-event',
    employee = 'employee',
    employeeRecord = 'employee-record',
    maintenanceTask = 'maintenance-task',
    factoryMoveRequest = 'factory-move-request',
    plasticsWeighRequest = 'plastics-weigh-request',

    plasticsMold = 'plastics-mold',
    plasticsMoldHistoryEvent = 'plastics-mold-history-event',
    plasticsMoldCheckup = 'plastics-mold-checkup',
    plasticsMoldNotice = 'plastics-mold-notice',
    plasticsMoldCheckupCommand = 'plastics-mold-checkup-command',
    plasticsMoldFamily = 'plastics-mold-family',
    moldArmCycle = 'mold-arm-cycle',

    c3HardwareItem = 'c3-hardware-item',
    c3VendorHardwareData = 'c3-vendor-hardware-data',
    c3Product = 'c3-product',
    c3Order = 'c3-order',
    c3OrderedProduct = 'c3-ordered-product',
    c3ProductVersion = 'c3-product-version',
    c3ProductBillOfMaterialsLineItem = 'c3-product-bill-of-materials-line-item',
    c3RiderBomNode = 'c3-rider-bom-node',
    c3Graphic = 'c3-graphic',
    c3GraphicVersion = 'c3-graphic-version',
    c3GraphicResource = 'c3-graphic-resource',
    printingProduct = 'printing-product',
    printingProductVersion = 'printing-product-version',
    printingProductFile = 'printing-product-file',
    printingProductBomItem = 'printing-product-bom-item',
    motionmasterProgram = 'motionmaster-program',
    motionmasterProgramVersion = 'motionmaster-program-version',
    motionmasterTable = 'motionmaster-table',
    c3Report = 'c3-report',
    c3InventoryThresholdReport = 'c3-inventory-threshold-report-detail',
    c3InventoryThresholdReportItem = 'c3-inventory-threshold-report-item',
    plasticsStaticLabel = 'plastics-static-label',
    plasticsManufacturingRates = 'plastics-manufacturing-rates',
    plasticsManufacturingRatesVersion = 'plastics-manufacturing-rates-version',
    quoteStudio = 'quote-studio',
    quoteStudioCostModel = 'quote-studio-cost-model',
    quoteStudioCostModelVersion = 'quote-studio-cost-model-version',
    quoteStudioLink = 'quote-studio-link',
    quoteStudioQuote = 'quote-studio-quote',
    quoteStudioCounter = 'quote-studio-counter',

    plasticsQualityAlert = 'plastics-quality-alert',
    mappingPlasticsMaterialToQualityAlert = 'mapping-plastics-material-to-quality-alert',


    metalsProject = 'metals-project',
    metalsTask = 'metals-task',
    metalsProcessStation = 'metals-process-station',
    metalsInventoryRack = 'metals-inventory-rack',
    metalsInventoryBin = 'metals-inventory-bin',

    productVersionMoldConfig = 'product-version-mold-config',
    metalsTaskQuantityChangeEvent = 'metals-task-quantity-change-event',

    plasticsHardwareItemShipment = 'plastics-hardware-item-shipment',
    plasticsHardwareItemShipmentItem = 'plastics-hardware-item-shipment-item',
    plasticsHardwareItemShipmentDamageItem = 'plastics-hardware-item-shipment-damage-item',
    plasticsInventoryLocation = 'plastics-inventory-location',
    plasticsInventoryLocationBin = 'plastics-inventory-location-bin',
    plasticsInventoryArea = 'plastics-inventory-area',

    plasticsKittingLocation = 'plastics-kitting-location',
    plasticsKittingLocationBin = 'plastics-kitting-location-bin',
    plasticsKittingArea = 'plastics-kitting-area',

    purchaseRequestArrival = 'purchase-request-arrival',
    purchaseOrderChange = 'purchase-order-change',
    purchaseRequestUnreadied = 'purchase-request-unreadied',

    metalsOrder = 'metals-order',
    metalsQuote = 'metals-quote',
    metalsOrderedProduct = 'metals-ordered-product',
    cloudFunctionFlag = 'cloud-function-flag',


    schematic = 'schematic',
    schematicVersion = 'schematic-version',
    automationHardwareItem = 'automation-hardware-item',
    automationVendorHardwareData = 'automation-vendor-hardware-data',
    automationFootprint = 'automation-footprint',
    automationFootprintVersion = 'automation-footprint-version',
    engineeringProjectEngineer = 'engineering-project-engineer',
    engineeringProject = 'engineering-project',
    engineeringFileProject = 'engineering-file-project',
    engineeringFileRevision = 'engineering-file-revision',

    directChat = 'direct-chat',
    directChatMessage = 'direct-chat-message',

    plasticsKit = 'plastics-kit',
    financeEntry = 'finance-entry',
    overtimeSummaryWeek = 'overtime-summary-week',

    inventoryTransaction = 'inventory-transaction',
    moldRepairRequest = 'mold-repair-request',
    hotListItem = 'hot-list-item',
    hotListOrderItem = 'hot-list-order-item',
    suncastSnapshot = 'suncast-snapshot',
    resinSiloReading = 'resin-silo-reading',
    resinSiloCaptureRequest = 'resin-silo-capture-request',
    triumvirateBarcodeScanningSession = 'triumvirate-barcode-scanning-session',
    obsessedEngineeringComponent = 'obsessed-engineering-component',
    obsessedEngineeringComponentShipment = 'oe-component-shipment',
    obsessedEngineeringComponentShipmentItem = 'oe-component-shipment-item',
    obsessedEngineeringComponentShipmentDamageItem = 'oe-component-shipment-damage-item',
    obsessedEngineeringProduct = 'obsessed-engineering-product',
    obsessedEngineeringProductVersion = 'obsessed-engineering-product-version',
    obsessedEngineeringProductBomLineItem = 'obsessed-engineering-product-bom',
    obsessedEngineeringOrder = 'obsessed-engineering-order',
    obsessedEngineeringOrderedProduct = 'obsessed-engineering-ordered-product',
    obsessedEngineeringInvoice = 'oe-invoice',
    plasticsInvoice = 'plastics-invoice',

    metalsProductSetup = 'metals-product-setup',
    toolRoomMachine = 'tool-room-machine',

    injectionMoldingProduct = 'injection-molding-product',
    injectionMoldingProductVersion = 'injection-molding-product-version',
    injectionMoldingProductBillOfMaterialsLineItem = 'injection-molding-product-bom-item',
    injectionMoldingQualityAlert = 'injection-molding-quality-alert',
    mappingInjectionMoldingProductVersionToQualityAlert = 'injection-molding-product-alert-map',
    injectionMoldingHardwareItem = 'injection-molding-hardware-item',
    injectionMoldingMaterial = 'injection-molding-material',
    injectionMoldingMaterialRecipeItem = 'injection-molding-recipe-item',
    injectionMoldingVendorHardwareData = 'injection-molding-vendor-data',
    injectionMoldingOrder = 'injection-molding-order',
    injectionMoldingOrderedProduct = 'injection-molding-ordered-product',
    injectionMoldingProductionEvent = 'injection-molding-production-event',
    injectionMoldingMold = 'injection-molding-mold',
    injectionMoldingMoldSetup = 'injection-molding-mold-setup',
}

export const APPWRITE_CONFIG = {
    defaultBucketId: 'default',
    collections: {
        plasticsHardwareItem: Collection.plasticsHardwareItem,
        product: Collection.product,
        productVersion: Collection.productVersion,
        labelPrinter: Collection.labelPrinter,
        labelPrinterGroup: Collection.labelPrinterGroup,
        wifiOutlet: Collection.wifiOutlet,
        factoryAsset: Collection.factoryAsset,
        resource: Collection.resource,
        resourceSearchPackage: Collection.resourceSearchPackage,
        plasticsScrapInstance: Collection.plasticsScrapInstance,
        plasticsRework: Collection.plasticsRework,
        assetHistoryEvent: Collection.assetHistoryEvent,
        mappingAssetToResource: Collection.mappingAssetToResource,
        mappingAssetToProcedure: Collection.mappingAssetToProcedure,
        factoryNode: Collection.factoryNode,
        factoryNodeConfig: Collection.factoryNodeConfig,
        robotProgramGroup: Collection.robotProgramGroup,
        robotProgram: Collection.robotProgram,
        plasticsMold: Collection.plasticsMold,
        plasticsMoldHistoryEvent: Collection.plasticsMoldHistoryEvent,
        mappingPlasticsMaterialToQualityAlert: Collection.mappingPlasticsMaterialToQualityAlert,
        plasticsQualityAlertInspection: Collection.plasticsQualityAlertInspection,
        qualityAlertViewTally: Collection.qualityAlertViewTally,
        purchaseRequestList: Collection.purchaseRequestList,
        purchaseRequest: Collection.purchaseRequest,
        purchaseOrder: Collection.purchaseOrder,
        purchaseRequestArrival: Collection.purchaseRequestArrival,
        purchaseOrderChange: Collection.purchaseOrderChange,
        purchaseRequestUnreadied: Collection.purchaseRequestUnreadied,
        c3HardwareItem: Collection.c3HardwareItem,
        c3VendorHardwareData: Collection.c3VendorHardwareData,
        c3Product: Collection.c3Product,
        c3Order: Collection.c3Order,
        c3OrderedProduct: Collection.c3OrderedProduct,
        c3ProductVersion: Collection.c3ProductVersion,
        c3ProductBillOfMaterialsLineItem: Collection.c3ProductBillOfMaterialsLineItem,
        c3RiderBomNode: Collection.c3RiderBomNode,
        c3Graphic: Collection.c3Graphic,
        c3GraphicVersion: Collection.c3GraphicVersion,
        c3GraphicResource: Collection.c3GraphicResource,
        printingProduct: Collection.printingProduct,
        printingProductVersion: Collection.printingProductVersion,
        printingProductFile: Collection.printingProductFile,
        printingProductBomItem: Collection.printingProductBomItem,
        motionmasterProgram: Collection.motionmasterProgram,
        motionmasterProgramVersion: Collection.motionmasterProgramVersion,
        motionmasterTable: Collection.motionmasterTable,
        plasticsManufacturingRates: Collection.plasticsManufacturingRates,
        plasticsManufacturingRatesVersion: Collection.plasticsManufacturingRatesVersion,
        quoteStudio: Collection.quoteStudio,
        quoteStudioCostModel: Collection.quoteStudioCostModel,
        quoteStudioCostModelVersion: Collection.quoteStudioCostModelVersion,
        quoteStudioLink: Collection.quoteStudioLink,
        quoteStudioQuote: Collection.quoteStudioQuote,
        quoteStudioCounter: Collection.quoteStudioCounter,
        softwareRequest: Collection.softwareRequest,
        smartJeffProject: Collection.smartJeffProject,
        commonProject: Collection.commonProject,
        commonProjectUpdate: Collection.commonProjectUpdate,
        capitalizationProject: Collection.capitalizationProject,
        factoryMoveRequest: Collection.factoryMoveRequest,
        plasticsWeighRequest: Collection.plasticsWeighRequest,
        hotListItem: Collection.hotListItem,
        hotListOrderItem: Collection.hotListOrderItem,
        softwareTask: Collection.softwareTask,
        knowledgeDocument: Collection.knowledgeDocument,
        engineeringUpdateMeeting: Collection.engineeringUpdateMeeting,
        engineeringUpdateMeetingUserContent: Collection.engineeringUpdateMeetingUserContent,
        financeEntry: Collection.financeEntry,
        overtimeSummaryWeek: Collection.overtimeSummaryWeek,
        directChat: Collection.directChat,
        directChatMessage: Collection.directChatMessage,
        userTimeSession: Collection.userTimeSession,
        cronJob: Collection.cronJob,
        gmailUserLogin: Collection.gmailUserLogin,
        gmailUser: Collection.gmailUser,
        gmailUserDevice: Collection.gmailUserDevice,
        cloudFunctionFlag: Collection.cloudFunctionFlag,
        databaseBackupRecord: Collection.databaseBackupRecord,
        storageBackupRecord: Collection.storageBackupRecord,
        deviceDocumentReads: Collection.deviceDocumentReads,
        trendsDataFileRecord: Collection.trendsDataFileRecord,
        cribbageGame: Collection.cribbageGame,
        stampingStation: Collection.stampingStation,
        stampingTask: Collection.stampingTask,
        freightCarrier: Collection.freightCarrier,
        schematics: Collection.schematic,
        automationFootprint: Collection.automationFootprint,
        automationFootprintVersion: Collection.automationFootprintVersion,
        trendsShareLink: Collection.trendsShareLink,
        vacationEvent: Collection.vacationEvent,
        employee: Collection.employee,
        employeeRecord: Collection.employeeRecord,
        triumvirateBarcodeScanningSession: Collection.triumvirateBarcodeScanningSession,
        obsessedEngineeringComponent: Collection.obsessedEngineeringComponent,
        obsessedEngineeringComponentShipment: Collection.obsessedEngineeringComponentShipment,
        obsessedEngineeringComponentShipmentItem: Collection.obsessedEngineeringComponentShipmentItem,
        obsessedEngineeringComponentShipmentDamageItem: Collection.obsessedEngineeringComponentShipmentDamageItem,
        obsessedEngineeringProduct: Collection.obsessedEngineeringProduct,
        obsessedEngineeringProductVersion: Collection.obsessedEngineeringProductVersion,
        obsessedEngineeringProductBomLineItem: Collection.obsessedEngineeringProductBomLineItem,
        obsessedEngineeringOrder: Collection.obsessedEngineeringOrder,
        obsessedEngineeringOrderedProduct: Collection.obsessedEngineeringOrderedProduct,
        obsessedEngineeringInvoice: Collection.obsessedEngineeringInvoice,
        injectionMoldingProduct: Collection.injectionMoldingProduct,
        injectionMoldingProductVersion: Collection.injectionMoldingProductVersion,
        injectionMoldingProductBillOfMaterialsLineItem: Collection.injectionMoldingProductBillOfMaterialsLineItem,
        injectionMoldingQualityAlert: Collection.injectionMoldingQualityAlert,
        mappingInjectionMoldingProductVersionToQualityAlert: Collection.mappingInjectionMoldingProductVersionToQualityAlert,
        injectionMoldingHardwareItem: Collection.injectionMoldingHardwareItem,
        injectionMoldingMaterial: Collection.injectionMoldingMaterial,
        injectionMoldingMaterialRecipeItem: Collection.injectionMoldingMaterialRecipeItem,
        injectionMoldingVendorHardwareData: Collection.injectionMoldingVendorHardwareData,
        injectionMoldingOrder: Collection.injectionMoldingOrder,
        injectionMoldingOrderedProduct: Collection.injectionMoldingOrderedProduct,
        injectionMoldingProductionEvent: Collection.injectionMoldingProductionEvent,
        injectionMoldingMold: Collection.injectionMoldingMold,
        injectionMoldingMoldSetup: Collection.injectionMoldingMoldSetup,
    },
    buckets: {
        sheetMetalPart: Collection.sheetMetalPart,
        plasticsHardwareItem: Collection.plasticsHardwareItem,
        productVersion: Collection.productVersion,
        injectionMoldingProductVersion: Collection.injectionMoldingProductVersion,
        injectionMoldingQualityAlert: Collection.injectionMoldingQualityAlert,
        injectionMoldingHardwareItem: Collection.injectionMoldingHardwareItem,
        injectionMoldingMaterial: Collection.injectionMoldingMaterial,
        injectionMoldingOrder: Collection.injectionMoldingOrder,
        injectionMoldingMold: Collection.injectionMoldingMold,
        labelPrinter: Collection.labelPrinter,
        factoryAsset: Collection.factoryAsset,
        resource: Collection.resource,
        resourceSearchPackage: Collection.resourceSearchPackage,
        plasticsScrapInstance: Collection.plasticsScrapInstance,
        assetHistoryEvent: Collection.assetHistoryEvent,
        mappingAssetToResource: Collection.mappingAssetToResource,
        mappingAssetToProcedure: Collection.mappingAssetToProcedure,
        factoryNode: Collection.factoryNode,
        factoryNodeConfig: Collection.factoryNodeConfig,
        robotProgramGroup: Collection.robotProgramGroup,
        robotProgram: Collection.robotProgram,
        plasticsMold: Collection.plasticsMold,
        plasticsMoldHistoryEvent: Collection.plasticsMoldHistoryEvent,
        mappingPlasticsMaterialToQualityAlert: Collection.mappingPlasticsMaterialToQualityAlert,
        plasticsQualityAlertInspection: Collection.plasticsQualityAlertInspection,
        qualityAlertViewTally: Collection.qualityAlertViewTally,
        purchaseRequestList: Collection.purchaseRequestList,
        purchaseRequest: Collection.purchaseRequest,
        purchaseOrder: Collection.purchaseOrder,
        purchaseRequestArrival: Collection.purchaseRequestArrival,
        purchaseOrderChange: Collection.purchaseOrderChange,
        purchaseRequestUnreadied: Collection.purchaseRequestUnreadied,
        c3HardwareItem: Collection.c3HardwareItem,
        c3VendorHardwareData: Collection.c3VendorHardwareData,
        c3Product: Collection.c3Product,
        c3Order: Collection.c3Order,
        c3ProductVersion: Collection.c3ProductVersion,
        c3ProductBillOfMaterialsLineItem: Collection.c3ProductBillOfMaterialsLineItem,
        c3GraphicResource: Collection.c3GraphicResource,
        printingProductFile: Collection.printingProductFile,
        c3RiderBomNode: Collection.c3RiderBomNode,
        softwareRequest: Collection.softwareRequest,
        smartJeffProject: Collection.smartJeffProject,
        commonProject: Collection.commonProject,
        capitalizationProject: Collection.capitalizationProject,
        factoryMoveRequest: Collection.factoryMoveRequest,
        softwareTask: Collection.softwareTask,
        knowledgeDocument: Collection.knowledgeDocument,
        engineeringUpdateMeeting: Collection.engineeringUpdateMeeting,
        engineeringUpdateMeetingUserContent: Collection.engineeringUpdateMeetingUserContent,
        financeEntry: Collection.financeEntry,
        directChat: Collection.directChat,
        directChatMessage: Collection.directChatMessage,
        userTimeSession: Collection.userTimeSession,
        cronJob: Collection.cronJob,
        gmailUserLogin: Collection.gmailUserLogin,
        gmailUser: Collection.gmailUser,
        gmailUserDevice: Collection.gmailUserDevice,
        cloudFunctionFlag: Collection.cloudFunctionFlag,
        databaseBackupRecord: Collection.databaseBackupRecord,
        storageBackupRecord: Collection.storageBackupRecord,
        deviceDocumentReads: Collection.deviceDocumentReads,
        trendsDataFileRecord: Collection.trendsDataFileRecord,
        cribbageGame: Collection.cribbageGame,
        stampingStation: Collection.stampingStation,
        stampingTask: Collection.stampingTask,
        freightCarrier: Collection.freightCarrier,
        schematics: Collection.schematic,
        trendsShareLink: Collection.trendsShareLink,
        vacationEvent: Collection.vacationEvent,
        employee: Collection.employee,
        employeeRecord: Collection.employeeRecord,
        triumvirateBarcodeScanningSession: Collection.triumvirateBarcodeScanningSession,
        obsessedEngineeringProduct: Collection.obsessedEngineeringProduct,
        obsessedEngineeringOrder: Collection.obsessedEngineeringOrder,
        obsessedEngineeringInvoice: Collection.obsessedEngineeringInvoice,
        obsessedEngineeringComponentShipment: Collection.obsessedEngineeringComponentShipment,
    },
};

export function toAppwriteStorageBucketId(bucketOrFolder: string): string {
    const bucketByLegacyFolder: Record<string, string> = {
        [StorageFolder.user]: Collection.user,
        [StorageFolder.customer]: Collection.customer,
        [StorageFolder.vendor]: Collection.vendor,
        [StorageFolder.contact]: Collection.contact,
        [StorageFolder.product]: Collection.productVersion,
        [StorageFolder.injectionMoldingProduct]: Collection.injectionMoldingProductVersion,
        [StorageFolder.injectionMoldingQualityAlerts]: Collection.injectionMoldingQualityAlert,
        [StorageFolder.metalsProduct]: Collection.metalsProductVersion,
        [StorageFolder.c3Product]: Collection.c3ProductVersion,
        [StorageFolder.c3Order]: Collection.c3Order,
        [StorageFolder.injectionMoldingOrder]: Collection.injectionMoldingOrder,
        [StorageFolder.injectionMoldingMold]: Collection.injectionMoldingMold,
        [StorageFolder.hardwareItem]: Collection.plasticsHardwareItem,
        [StorageFolder.injectionMoldingHardwareItem]: Collection.injectionMoldingHardwareItem,
        [StorageFolder.metalsHardwareItem]: Collection.metalsHardwareItem,
        [StorageFolder.vendorHardwareData]: Collection.vendorHardwareData,
        [StorageFolder.c3HardwareItems]: Collection.c3HardwareItem,
        [StorageFolder.c3VendorHardwareData]: Collection.c3VendorHardwareData,
        [StorageFolder.plasticsMaterial]: Collection.plasticsMaterial,
        [StorageFolder.injectionMoldingMaterial]: Collection.injectionMoldingMaterial,
        [StorageFolder.plasticsFixture]: Collection.plasticsFixture,
        [StorageFolder.plasticsMold]: Collection.plasticsMold,
        [StorageFolder.plasticsMoldHistoryEvent]: Collection.plasticsMoldHistoryEvent,
        [StorageFolder.plasticsOrder]: Collection.plasticsOrder,
        [StorageFolder.plasticsShipment]: Collection.plasticsShipment,
        [StorageFolder.plasticsSkid]: Collection.plasticsSkid,
        [StorageFolder.plasticsScrap]: Collection.plasticsScrapInstance,
        [StorageFolder.plasticsProductsQualityAlerts]: Collection.plasticsQualityAlert,
        [StorageFolder.qualityAlerts]: Collection.plasticsQualityAlert,
        [StorageFolder.qualityInspections]: Collection.plasticsQualityAlertInspection,
        [StorageFolder.dockInspections]: Collection.dockInspectionInstance,
        [StorageFolder.plasticsHardwareItemShipment]: Collection.plasticsHardwareItemShipment,
        [StorageFolder.purchasing]: Collection.purchaseRequest,
        [StorageFolder.metalsOrder]: Collection.metalsOrder,
        [StorageFolder.obsessedEngineeringProduct]: Collection.obsessedEngineeringProduct,
        [StorageFolder.obsessedEngineeringOrder]: Collection.obsessedEngineeringOrder,
        [StorageFolder.obsessedEngineeringInvoice]: StorageFolder.obsessedEngineeringInvoice,
        [StorageFolder.obsessedEngineeringComponentShipment]: Collection.obsessedEngineeringComponentShipment,
        [StorageFolder.metalsProject]: Collection.metalsProject,
        [StorageFolder.metaltrackJob]: Collection.metaltrackJob,
        [StorageFolder.procedure]: Collection.procedure,
        [StorageFolder.procedureInstance]: Collection.procedureInstance,
        [StorageFolder.procedureRedline]: Collection.procedureStepRedline,
        [StorageFolder.asset]: Collection.factoryAsset,
        [StorageFolder.assetHistoryEvents]: Collection.assetHistoryEvent,
        [StorageFolder.prismResource]: Collection.resource,
        [StorageFolder.robotProgram]: Collection.robotProgram,
        [StorageFolder.softwareRequests]: Collection.softwareRequest,
        [StorageFolder.smartJeffProject]: Collection.smartJeffProject,
        [StorageFolder.commonProject]: Collection.commonProject,
        [StorageFolder.capitalizationProject]: Collection.capitalizationProject,
        [StorageFolder.factoryMoveRequest]: Collection.factoryMoveRequest,
        [StorageFolder.metalsProductSetup]: Collection.metalsProductSetup,
        [StorageFolder.toolRoomMachine]: Collection.toolRoomMachine,
        [StorageFolder.employee]: Collection.employee,
        [StorageFolder.employeeRecord]: Collection.employeeRecord,
        [StorageFolder.softwareTasks]: Collection.softwareTask,
        [StorageFolder.engineeringUpdateMeeting]: Collection.engineeringUpdateMeeting,
        [StorageFolder.knowledgeDocument]: Collection.knowledgeDocument,
        [StorageFolder.directChat]: Collection.directChat,
        [StorageFolder.trendsData]: Collection.trendsDataFileRecord,
        [StorageFolder.freightCarriers]: Collection.freightCarrier,
        [StorageFolder.automationHardwareItem]: Collection.automationHardwareItem,
        [StorageFolder.complaintLog]: Collection.complaintLog,
        [StorageFolder.cribbageGames]: Collection.cribbageGame,
        [StorageFolder.maintenance]: Collection.maintenanceTask,
        [StorageFolder.suncastSnapshot]: Collection.suncastSnapshot,
    };

    return bucketByLegacyFolder[bucketOrFolder] || bucketOrFolder;
}

export const COPY_ALL_BLACKLIST: Collection[] = [
    Collection.clientDeviceLog,
    Collection.deviceDocumentReads,
    Collection.metaltrackJob,
    Collection.rotoMachineArmTally,
    Collection.trendsDataFileRecord,
    Collection.productInstance,
];

type CollectionTypeMap = {
    [Collection.email]: Email;
    [Collection.vendor]: Vendor;
    [Collection.customer]: Customer;
    [Collection.customerNoteVersion]: CustomerNoteVersion;
    [Collection.customerAddress]: CustomerAddress;
    [Collection.product]: Product;
    [Collection.cronJob]: CronJob;
    [Collection.factoryNode]: FactoryNode;
    [Collection.factoryNodeConfig]: FactoryNodeConfig;
    [Collection.plasticsHardwareItem]: PlasticsHardwareItem;
    [Collection.metalsHardwareItem]: MetalsHardwareItem;
    [Collection.metalsMaterial]: MetalsMaterial;
    [Collection.contact]: Contact;
    [Collection.productVersion]: ProductVersion;
    [Collection.billOfMaterialsLineItem]: BillOfMaterialsLineItem;
    [Collection.metalsProductBillOfMaterialsLineItem]: MetalsProductBillOfMaterialsLineItem;
    [Collection.resource]: Resource;
    [Collection.resourceSearchPackage]: ResourceSearchPackage;
    [Collection.productInstance]: ProductInstance;
    [Collection.procedure]: Procedure;
    [Collection.procedureVersion]: ProcedureVersion;
    [Collection.masterProcedure]: MasterProcedure;
    [Collection.masterProcedureVersion]: MasterProcedureVersion;
    [Collection.procedureInstance]: ProcedureInstance;
    [Collection.procedureInstanceStep]: ProcedureInstanceStep;
    [Collection.procedureStepRedline]: ProcedureStepRedline;
    [Collection.scheduledProcedure]: ScheduledProcedure;
    [Collection.plasticsMaterial]: PlasticsMaterial;
    [Collection.plasticsMaterialMixingTask]: PlasticsMaterialMixingTask;
    [Collection.plasticsPurchaseRequisition]: PlasticsPurchaseRequisition;
    [Collection.plasticsScrapReason]: PlasticsScrapReason;
    [Collection.plasticsScrapInstance]: PlasticsScrapInstance;
    [Collection.plasticsOrder]: PlasticsOrder;
    [Collection.plasticsOrderedProduct]: PlasticsOrderedProduct;
    [Collection.plasticsOrderReviewResearch]: PlasticsOrderReviewResearch;
    [Collection.plasticsOrderReviewRulebook]: {
        id: string;
        /** `file` documents hold one published script or reference as raw text; a release lists them in `files`. */
        kind: 'pointer' | 'release' | 'file';
        version: string;
        contentHash: string;
        contentJson: string;
        createdBy: string;
        createdOn: string;
    };
    [Collection.plasticsOrderIntake]: {
        id: string; customerId: string; customerPurchaseOrderNumber: string; sourceLineKey: string;
        status: string; contentHash: string; contentJson: string; updatedOn: string;
    };
    [Collection.plasticsOrderIntakeApproval]: {
        id: string; intakeId: string; contentHash: string; approvedById: string; approvedOn: string; kind: string;
    };
    /** One received customer order (email PO) moving through the order-entry gate. contentJson is the bot proposal; decisionsJson is the reviewer's choices. */
    [Collection.plasticsOrderCase]: {
        id: string; customerId: string; customerName: string; customerPurchaseOrderNumber: string; status: string; sourceKind: string;
        receivedOn: string; messageId: string; threadId: string; sourceFileId: string; sourceSha256: string; existingOrderId: string;
        contentHash: string; contentJson: string; decisionsJson: string; updatedOn: string; updatedById: string;
    };
    [Collection.plasticsCalendarEvent]: PlasticsCalendarEvent;
    [Collection.plasticsColorCode]: PlasticsColorCode;
    [Collection.labelPrinter]: LabelPrinter;
    [Collection.labelPrinterGroup]: LabelPrinterGroup;
    [Collection.wifiOutlet]: WifiOutlet;
    [Collection.plasticsFinishingTask]: PlasticsFinishingTask;
    [Collection.plasticsFinishingStation]: PlasticsFinishingStation;
    [Collection.plasticsFinishingLaborSession]: PlasticsFinishingLaborSession;
    [Collection.kolorcansPackingConfig]: KolorcansPackingConfig;
    [Collection.kolorcansPackingConfigProduct]: KolorcansPackingConfigProduct;
    [Collection.cribbageGame]: CribbageGame;
    [Collection.metalsProduct]: MetalsProduct;
    [Collection.metalsProductVersion]: MetalsProductVersion;
    [Collection.stampingStation]: StampingStation;
    [Collection.stampingTask]: StampingTask;
    [Collection.deviceDocumentReads]: DeviceDocumentReads;
    [Collection.databaseBackupRecord]: DatabaseBackupRecord;
    [Collection.storageBackupRecord]: StorageBackupRecord;
    [Collection.complaintLog]: ComplaintLog;
    [Collection.complaintLogProduct]: ComplaintLogProduct;
    [Collection.plasticsRework]: PlasticsRework;
    [Collection.rotoMachineArmTally]: RotoMachineArmTally;
    [Collection.qualityAlertViewTally]: QualityAlertViewTally;
    [Collection.plasticsLabelInstance]: LabelInstance;
    [Collection.plasticsQualityAlertInspection]: PlasticsQualityAlertInspection;
    [Collection.plasticsSkid]: PlasticsSkid;
    [Collection.plasticsShipment]: PlasticsShipment;
    [Collection.upsShipment]: UpsShipment;
    [Collection.factoryAsset]: FactoryAsset;
    [Collection.assetHistoryEvent]: AssetHistoryEvent;
    [Collection.freightCarrier]: FreightCarrier;
    [Collection.purchaseRequestList]: PurchaseRequestList;
    [Collection.purchaseRequest]: PurchaseRequest;
    [Collection.purchaseOrder]: PurchaseOrder;
    [Collection.softwareRequest]: SoftwareRequest;
    [Collection.smartJeffProject]: SmartJeffProject;
    [Collection.commonProject]: CommonProject;
    [Collection.commonProjectUpdate]: CommonProjectUpdate;
    [Collection.capitalizationProject]: CapitalizationProject;
    [Collection.factoryMoveRequest]: FactoryMoveRequest;
    [Collection.plasticsWeighRequest]: PlasticsWeighRequest;
    [Collection.mappingAssetToResource]: MappingAssetToResource;
    [Collection.mappingAssetToProcedure]: MappingAssetToProcedure;
    [Collection.mappingProductVersionToQualityAlert]: MappingProductVersionToQualityAlert;
    [Collection.mappingProductVersionToDockInspectionQualityAlert]: MappingProductVersionToDockInspectionQuailtyAlert;
    [Collection.mappingComplaintLogToQualityAlert]: MappingComplaintLogToQualityAlert;
    [Collection.mappingComplaintLogToContact]: MappingComplaintLogToContact;
    [Collection.robotProgramGroup]: RobotProgramGroup;
    [Collection.robotProgram]: RobotProgram;
    [Collection.plasticsFixture]: PlasticsFixture;
    [Collection.rotoMachine]: RotoMachine;
    [Collection.clientDevice]: ClientDevice;
    [Collection.clientDeviceLog]: ClientDeviceLog;
    [Collection.softwareTask]: SoftwareTask;
    [Collection.engineeringUpdateMeeting]: EngineeringUpdateMeeting;
    [Collection.engineeringUpdateMeetingUserContent]: EngineeringUpdateMeetingUserContent;
    [Collection.knowledgeDocument]: KnowledgeDocument;
    [Collection.dockInspectionInstance]: PlasticsDockInspectionInstance;
    [Collection.trendsDataFileRecord]: TrendsDataFileRecord;
    [Collection.trendsShareLink]: TrendsShareLink;
    [Collection.vendorHardwareData]: VendorHardwareData;
    [Collection.vendorHardwareDataPriceHistory]: VendorHardwareDataPriceHistory;
    [Collection.metalsVendorHardwareData]: MetalsVendorHardwareData;
    [Collection.user]: User;
    [Collection.userTimeSession]: UserTimeSession;
    [Collection.tag]: Tag;
    [Collection.metalsLaserProgram]: MetalsLaserProgram;
    [Collection.metalsLaserMaterial]: MetalsLaserMaterial;
    [Collection.sheetMetalJob]: SheetMetalJob;
    [Collection.sheetMetalSourceFile]: SheetMetalSourceFile;
    [Collection.sheetMetalPart]: SheetMetalPart;
    [Collection.globalVariables]: any;
    [Collection.metaltrackJob]: MetaltrackJob;
    [Collection.plasticsMoldingTask]: PlasticsMoldingTask;
    [Collection.plasticsDailyProduction]: PlasticsDailyProduction;
    [Collection.userNotification]: UserNotification;
    [Collection.vacationEvent]: VacationEvent;
    [Collection.employee]: Employee;
    [Collection.employeeRecord]: EmployeeRecord;
    [Collection.maintenanceTask]: MaintenanceTask;
    [Collection.plasticsMold]: PlasticsMold,
    [Collection.plasticsMoldHistoryEvent]: PlasticsMoldHistoryEvent,
    [Collection.plasticsMoldCheckup]: PlasticsMoldCheckup,
    [Collection.plasticsMoldNotice]: PlasticsMoldNotice,
    [Collection.plasticsMoldCheckupCommand]: PlasticsMoldCheckupCommandReceipt,
    [Collection.plasticsMoldFamily]: PlasticsMoldFamily,
    [Collection.moldArmCycle]: MoldArmCycle,
    [Collection.c3HardwareItem]: C3HardwareItem;
    [Collection.c3VendorHardwareData]: C3VendorHardwareData;
    [Collection.c3Product]: C3Product;
    [Collection.c3Order]: C3Order;
    [Collection.c3OrderedProduct]: C3OrderedProduct;
    [Collection.c3ProductVersion]: C3ProductVersion;
    [Collection.c3ProductBillOfMaterialsLineItem]: C3ProductBillOfMaterialsLineItem;
    [Collection.c3RiderBomNode]: C3RiderBomNode;
    [Collection.c3Graphic]: C3Graphic;
    [Collection.c3GraphicVersion]: C3GraphicVersion;
    [Collection.c3GraphicResource]: C3GraphicResource;
    [Collection.printingProduct]: PrintingProduct;
    [Collection.printingProductVersion]: PrintingProductVersion;
    [Collection.printingProductFile]: PrintingProductFile;
    [Collection.printingProductBomItem]: PrintingProductBomItem;
    [Collection.motionmasterProgram]: MotionmasterProgram;
    [Collection.motionmasterProgramVersion]: MotionmasterProgramVersion;
    [Collection.motionmasterTable]: MotionmasterTable;
    [Collection.c3Report]: C3Report;
    [Collection.c3InventoryThresholdReport]: C3InventoryThresholdReport;
    [Collection.c3InventoryThresholdReportItem]: C3InventoryThresholdReportItem;
    [Collection.plasticsStaticLabel]: PlasticsStaticLabel;
    [Collection.plasticsManufacturingRates]: PlasticsManufacturingRatesParent;
    [Collection.plasticsManufacturingRatesVersion]: PlasticsManufacturingRatesVersion;
    [Collection.quoteStudio]: QuoteStudio;
    [Collection.quoteStudioCostModel]: QuoteStudioCostModel;
    [Collection.quoteStudioCostModelVersion]: QuoteStudioCostModelVersion;
    [Collection.quoteStudioLink]: QuoteStudioLink;
    [Collection.quoteStudioQuote]: QuoteStudioQuote;
    /** one row; `lastIssued` is atomically incremented to hand out quote numbers */
    [Collection.quoteStudioCounter]: { id: string; lastIssued: number };
    [Collection.mappingProductVersionToPlasticsStaticLabel]: MappingProductVersionToPlasticsStaticLabel;
    [Collection.mappingProductVersionToQuoteStudioCostModel]: MappingProductVersionToQuoteStudioCostModel;
    [Collection.mappingProductVersionToQuoteStudioQuote]: MappingProductVersionToQuoteStudioQuote;

    [Collection.plasticsQualityAlert]: PlasticsQualityAlert;
    [Collection.mappingPlasticsMaterialToQualityAlert]: MappingPlasticsMaterialToQualityAlert;
    [Collection.gmailUserLogin]: GmailUserLogin;
    [Collection.gmailUser]: GmailUser;
    [Collection.gmailUserDevice]: GmailUserDevice;
    [Collection.metalsProject]: MetalsProject;
    [Collection.metalsTask]: MetalsTask;
    [Collection.metalsPressBrakeBendRadius]: MetalsPressBrakeBendRadius;
    [Collection.metalsPowderCoatingPowder]: MetalsPowderCoatingPowder;
    [Collection.metalsProcessStation]: MetalsProcessStation;
    [Collection.metalsInventoryRack]: MetalsInventoryRack;
    [Collection.metalsInventoryBin]: MetalsInventoryBin;
    [Collection.productVersionMoldConfig]: ProductVersionMoldConfig;
    [Collection.metalsTaskQuantityChangeEvent]: MetalsTaskQuantityChangeEvent;
    [Collection.plasticsHardwareItemShipment]: PlasticsHardwareItemShipment;
    [Collection.plasticsHardwareItemShipmentItem]: PlasticsHardwareItemShipmentItem;
    [Collection.plasticsHardwareItemShipmentDamageItem]: PlasticsHardwareItemShipmentDamageItem;
    [Collection.plasticsInventoryLocation]: PlasticsInventoryLocation;
    [Collection.plasticsInventoryLocationBin]: PlasticsInventoryLocationBin;
    [Collection.plasticsInventoryArea]: PlasticsInventoryArea;
    [Collection.purchaseRequestArrival]: PurchaseRequestArrival;
    [Collection.purchaseOrderChange]: PurchaseOrderChange;
    [Collection.purchaseRequestUnreadied]: PurchaseRequestUnreadied;

    [Collection.metalsOrder]: MetalsOrder;
    [Collection.metalsQuote]: MetalsQuote;
    [Collection.metalsOrderedProduct]: MetalsOrderedProduct;
    [Collection.cloudFunctionFlag]: CloudFunctionFlag;

    [Collection.schematic]: Schematic;
    [Collection.schematicVersion]: SchematicVersion;
    [Collection.automationHardwareItem]: AutomationHardwareItem;
    [Collection.automationVendorHardwareData]: AutomationVendorHardwareData;
    [Collection.automationFootprint]: AutomationFootprint;
    [Collection.automationFootprintVersion]: AutomationFootprintVersion;
    [Collection.engineeringProjectEngineer]: EngineeringProjectEngineer;
    [Collection.engineeringProject]: EngineeringProject;
    [Collection.engineeringFileProject]: import('../models/engineering-project-files.model').EngineeringFileProject;
    [Collection.engineeringFileRevision]: import('../models/engineering-project-files.model').EngineeringFileRevision;

    [Collection.directChat]: DirectChat;
    [Collection.directChatMessage]: DirectChatMessage;
    [Collection.plasticsKit]: PlasticsKit;
    [Collection.financeEntry]: FinanceEntry;
    [Collection.overtimeSummaryWeek]: OvertimeSummaryWeek;
    [Collection.plasticsKittingLocation]: PlasticsKittingLocation;
    [Collection.plasticsKittingLocationBin]: PlasticsKittingLocationBin;
    [Collection.plasticsKittingArea]: PlasticsKittingArea;

    [Collection.inventoryTransaction]: InventoryTransaction;
    [Collection.moldRepairRequest]: MoldRepairRequest;
    [Collection.hotListItem]: HotListItem;
    [Collection.hotListOrderItem]: HotListOrderItem;

    [Collection.suncastSnapshot]: SuncastSnapshot;
    [Collection.resinSiloReading]: ResinSiloReading;
    [Collection.resinSiloCaptureRequest]: ResinSiloCaptureRequest;
    [Collection.triumvirateBarcodeScanningSession]: TriumvirateBarcodeScanningSession;
    [Collection.obsessedEngineeringComponent]: ObsessedEngineeringComponent;
    [Collection.obsessedEngineeringComponentShipment]: ObsessedEngineeringComponentShipment;
    [Collection.obsessedEngineeringComponentShipmentItem]: ObsessedEngineeringComponentShipmentItem;
    [Collection.obsessedEngineeringComponentShipmentDamageItem]: ObsessedEngineeringComponentShipmentDamageItem;
    [Collection.obsessedEngineeringProduct]: ObsessedEngineeringProduct;
    [Collection.obsessedEngineeringProductVersion]: ObsessedEngineeringProductVersion;
    [Collection.obsessedEngineeringProductBomLineItem]: ObsessedEngineeringProductBomLineItem;
    [Collection.obsessedEngineeringOrder]: ObsessedEngineeringOrder;
    [Collection.obsessedEngineeringOrderedProduct]: ObsessedEngineeringOrderedProduct;
    [Collection.obsessedEngineeringInvoice]: ObsessedEngineeringInvoice;
    [Collection.plasticsInvoice]: PlasticsInvoice;
    [Collection.truckingCarrier]: LegacyCarrier;
    [Collection.metalsProductSetup]: MetalsProductSetup;
    [Collection.toolRoomMachine]: ToolRoomMachine;
    [Collection.injectionMoldingProduct]: InjectionMoldingProduct;
    [Collection.injectionMoldingProductVersion]: InjectionMoldingProductVersion;
    [Collection.injectionMoldingProductBillOfMaterialsLineItem]: InjectionMoldingProductBillOfMaterialsLineItem;
    [Collection.injectionMoldingQualityAlert]: InjectionMoldingQualityAlert;
    [Collection.mappingInjectionMoldingProductVersionToQualityAlert]: MappingInjectionMoldingProductVersionToQualityAlert;
    [Collection.injectionMoldingHardwareItem]: InjectionMoldingHardwareItem;
    [Collection.injectionMoldingMaterial]: InjectionMoldingMaterial;
    [Collection.injectionMoldingMaterialRecipeItem]: InjectionMoldingMaterialRecipeItem;
    [Collection.injectionMoldingVendorHardwareData]: InjectionMoldingVendorHardwareData;
    [Collection.injectionMoldingOrder]: InjectionMoldingOrder;
    [Collection.injectionMoldingOrderedProduct]: InjectionMoldingOrderedProduct;
    [Collection.injectionMoldingProductionEvent]: InjectionMoldingProductionEvent;
    [Collection.injectionMoldingMold]: InjectionMoldingMold;
    [Collection.injectionMoldingMoldSetup]: InjectionMoldingMoldSetup;
};

export type CollectionMap = CollectionTypeMap;

type AssertCompleteness<T extends Record<Collection, any>> = T;
type ValidatedMap = AssertCompleteness<CollectionTypeMap>;
